import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotEnoughFundComponent } from 'src/app/features/bidders/component/auction/not-enough-fund/not-enough-fund.component';
import { RoomDetailesModal } from 'src/app/features/multi-auction-bidder/core/modal/roomDetailes-modal';
import { MultiAuctionService } from 'src/app/features/multi-auction-bidder/core/service/multi-auction.service';
import { JoinMultiRoomComponent } from './join-multi-room/join-multi-room.component';
import { WithdrawMultiRoomComponent } from './withdraw-multi-room/withdraw-multi-room.component';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-join-and-withdraw-room',
  templateUrl: './join-and-withdraw-room.component.html',
  styleUrls: []
})
export class JoinAndWithdrawRoomComponent implements OnInit {
  @Input() roomdetails!: RoomDetailesModal;
  @Output() joinSuccefully = new EventEmitter<any>();
  @Output() withdrawSuccefully = new EventEmitter<any>();
  constructor(public _api: MultiAuctionService, private dialog: MatDialog,
    public _config:ConfigService
  ) { }

  ngOnInit() {
  }
  onJoin() {


    const dialogRef = this.dialog.open(JoinMultiRoomComponent, {
      width: '550px',
      data: this.roomdetails,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {

      if (res == 'success') {
        this.roomdetails.joined_at = new Date();
        this.joinSuccefully.emit();
      }

    });

  }

  onWithdrawAuction() {
    const dialogRef = this.dialog.open(WithdrawMultiRoomComponent, {
      width: '550px',
      data: this.roomdetails,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {

      if (res == 'success') {
        this.withdrawSuccefully.emit();
      }

    });
  }
}
